import React, { useRef, useEffect, useState } from 'react';
import { MobileMenuIconLight } from './icons';
import { useLocation, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const MobileMenu = () => {
  const modalRef = useRef();
  const [pageState, setPageState] = useState("Sign In");
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Add state for menu open/close

  const location = useLocation();
  const navigate = useNavigate();

  const pathMachRoute = (route) => {
    if (route === location.pathname) {
      return true;
    }
  }

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        closeHamburger();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleHamburger = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const openHamburger = () => {
    setIsMenuOpen(true);
  };

  const closeHamburger = () => {
    setIsMenuOpen(false);
  };

  const auth = getAuth();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setPageState("Profile");
      } else {
        setPageState("Sign In");
      }
    });
  }, [auth]);

  return (
    <div className='flex md:hidden cursor-pointer' onClick={toggleHamburger}>
      <MobileMenuIconLight />
      <div 
        ref={modalRef} 
        className={`fixed inset-0 h-[100%] w-[50%] mt-[55px] flex items-center justify-center bg-[#202A54] z-custom-index ${isMenuOpen ? 'block' : 'hidden'}`}
        id="hamburger"
        style={{ right: 0, left: 'auto' }}
      >
        <div className="justify-center flex flex-col w-[100%] mx-[auto] h-[auto] items-center">
          <div className='gap-8 items-center flex flex-col'>
            <li className={`text-white text-base font-ClashRegular hover:text-link-hover hover:font-ClashSemiBold hover:text-link-hover ${pathMachRoute("/") && "text-black !border-b-[#F6D200]"}`} onClick={() => { navigate("/"); closeHamburger(); }}>Home</li>
            <li className={`text-white text-base font-ClashRegular hover:text-link-hover hover:font-ClashSemiBold hover:text-link-hover ${pathMachRoute("/about") && "text-black !border-b-[#F6D200]"}`} onClick={() => { navigate("/about"); closeHamburger(); }}>About Us</li>
            <li className={`text-white text-base font-ClashRegular hover:text-link-hover hover:font-ClashSemiBold hover:text-link-hover ${pathMachRoute("/products") && "text-black !border-b-[#F6D200]"}`} onClick={() => { navigate("/products"); closeHamburger(); }}>Products</li>
            <li className={`text-white text-base font-ClashRegular hover:text-link-hover hover:font-ClashSemiBold hover:text-link-hover ${pathMachRoute("/offers") && "text-black !border-b-[#F6D200]"}`} onClick={() => { navigate("/offers"); closeHamburger(); }}>Offers</li>
          </div>
          <div className='items-center mt-2'>
            <button className={`bg-[#F6D200] cursor-pointer py-2 px-5 text-sm font-semibold text-white rounded-lg border-b-[3px] border-b-transparent ${(pathMachRoute("/sign-in") || pathMachRoute("/profile")) && "text-black !border-b-red-500"}`} onClick={() => { navigate("/profile"); closeHamburger(); }}>
              {pageState}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
